"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackEvent = exports.getTrackEventQueryWithTrackingId = exports.getTagMutation = exports.getTrackEventQuery = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var getTrackEventQuery = function getTrackEventQuery(eventType) {
  return "\n  mutation TrackEvent(\n    $messageId: String!\n  ) {\n    ".concat(eventType, "(messageId: $messageId)\n  }\n");
};

exports.getTrackEventQuery = getTrackEventQuery;

var getTagMutation = function getTagMutation(eventType) {
  return "\n  mutation TrackEvent(\n    $messageId: String!\n    $tag: String!\n  ) {\n    ".concat(eventType, "(messageId: $messageId, tag: $tag)\n  }\n");
};

exports.getTagMutation = getTagMutation;

var getTrackEventQueryWithTrackingId = function getTrackEventQueryWithTrackingId(eventType) {
  return "\n  mutation TrackEvent(\n    $messageId: String!\n    $trackingId: String!\n  ) {\n    ".concat(eventType, "(messageId: $messageId, trackingId: $trackingId)\n  }\n");
};

exports.getTrackEventQueryWithTrackingId = getTrackEventQueryWithTrackingId;

var trackEvent = function trackEvent(client) {
  return function (eventType) {
    return /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(messageId, data) {
        var _results$data;

        var params, results, status;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (client) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", Promise.resolve(undefined));

              case 2:
                params = function () {
                  switch (eventType) {
                    case "clicked":
                      {
                        return {
                          mutation: getTrackEventQueryWithTrackingId(eventType),
                          variables: {
                            messageId: messageId,
                            trackingId: data === null || data === void 0 ? void 0 : data.trackingId
                          }
                        };
                      }

                    case "addTag":
                    case "removeTag":
                      {
                        return {
                          mutation: getTagMutation(eventType),
                          variables: {
                            messageId: messageId,
                            tag: data === null || data === void 0 ? void 0 : data.tag
                          }
                        };
                      }

                    default:
                      {
                        return {
                          mutation: getTrackEventQuery(eventType),
                          variables: {
                            messageId: messageId
                          }
                        };
                      }
                  }
                }();

                _context.next = 5;
                return client.mutation(params.mutation, params.variables).toPromise();

              case 5:
                results = _context.sent;
                status = results === null || results === void 0 ? void 0 : (_results$data = results.data) === null || _results$data === void 0 ? void 0 : _results$data[eventType];
                return _context.abrupt("return", (0, _defineProperty2["default"])({}, eventType, status));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
  };
};

exports.trackEvent = trackEvent;